import React, { ReactNode } from 'react';
import PageSection, { PrimaryActionProps } from '@/components/ui/PageSection';

interface TripDashboardSectionProps {
  icon: string;
  title: string;
  subtitle?: string;
  description?: string;
  primaryAction?: PrimaryActionProps;
  secondaryActions?: ReactNode;
  children: ReactNode;
}

const TripDashboardSection: React.FC<TripDashboardSectionProps> = ({
  icon,
  title,
  subtitle,
  description,
  primaryAction,
  secondaryActions,
  children
}) => {
  return (
    <PageSection
      icon={icon}
      title={title}
      subtitle={subtitle}
      description={description}
      primaryAction={primaryAction}
      secondaryActions={secondaryActions}
      titleVariant="h4"
      variant="default"
    >
      {children}
    </PageSection>
  );
};

export default TripDashboardSection;
